import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const smsIntegrationUrl = `${SERVER_API}/notification/sms-integrations`;
